<template>
  <app-modal name="publish-invoice-info-modal" click-to-close :title="title" :isAlert="true" :ok-text="okText" :cancel-text="cancelText" @on-ok="onOk">
    <div class="d-flex flex-column justify-content-center align-items-center text-center">
      <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M23.834 32.5002H28.1673V36.8335H23.834V32.5002ZM23.834 15.1668H28.1673V28.1668H23.834V15.1668ZM26.0006 4.3335C14.019 4.3335 4.33398 14.0835 4.33398 26.0002C4.33398 31.7465 6.61672 37.2575 10.68 41.3208C12.6919 43.3327 15.0805 44.9287 17.7092 46.0176C20.3379 47.1064 23.1553 47.6668 26.0006 47.6668C31.747 47.6668 37.258 45.3841 41.3213 41.3208C45.3846 37.2575 47.6673 31.7465 47.6673 26.0002C47.6673 23.1549 47.1069 20.3374 46.018 17.7087C44.9292 15.08 43.3332 12.6915 41.3213 10.6795C39.3094 8.66758 36.9208 7.07162 34.2921 5.98277C31.6634 4.89392 28.846 4.3335 26.0006 4.3335ZM26.0006 43.3335C21.4036 43.3335 16.9948 41.5073 13.7441 38.2567C10.4935 35.006 8.66732 30.5972 8.66732 26.0002C8.66732 21.4031 10.4935 16.9943 13.7441 13.7436C16.9948 10.493 21.4036 8.66683 26.0006 8.66683C30.5977 8.66683 35.0065 10.493 38.2572 13.7436C41.5078 16.9943 43.334 21.4031 43.334 26.0002C43.334 30.5972 41.5078 35.006 38.2572 38.2567C35.0065 41.5073 30.5977 43.3335 26.0006 43.3335Z" fill="#FFC226"/>
      </svg>
      <p class="mt-3 mb-0" style="color: #FFC226; font-size: 20px; font-weight: 600">
        {{ $t('dialog.publish-invoice-info-modal.content.infor-1') }}
      </p>
    </div>
  </app-modal>
</template>
<script>
import AppModal from '@/components/app-modal/';
import { EXTERNAL_URL } from '../../app-constant';

export default {
  name: 'AdvModal',
  components: {
    AppModal,
  },
  data() {
    return {
      title: '',
      okText: this.$t('dialog.publish-invoice-info-modal.actions.submit'),
      cancelText: this.$t('dialog.publish-invoice-info-modal.actions.cancel'),
    };
  },
  methods: {
    onOk() {
      const token = localStorage.getItem('id_token');
      const externalURL = token ? `${EXTERNAL_URL}&token=${token}` : EXTERNAL_URL;
      window.open(externalURL, '_blank');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/portal-components/invoice/publish-invoice-info-modal.vue